module.exports = __webpack_public_path__ + "img/toplogo_jiegui.1d71932f.png";